/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_StoppedInputs */

const th_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หยุดแล้ว`)
};

const en_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopped`)
};

const ja_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止`)
};

const zh_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已停止`)
};

const es_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detenida`)
};

const pt_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parada`)
};

const id_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti`)
};

const fr_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêtée`)
};

const tl_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinigil`)
};

const vi_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã dừng`)
};

const ko_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중지됨`)
};

const de_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestoppt`)
};

const ru_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Остановлено`)
};

const tr_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durduruldu`)
};

const it_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrotta`)
};

const pl_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrzymano`)
};

const uk_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зупинено`)
};

const hi_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रुका`)
};

const ar_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متوقف`)
};

const ms_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dihentikan`)
};

const bn_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`থেমেছে`)
};

const zh_tw2_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已停止`)
};

const zh_hk2_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已停止`)
};

const ur_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رک گیا`)
};

const fa_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متوقف شد`)
};

const sw_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imesimamishwa`)
};

const nl_video_stopped = /** @type {(inputs: Video_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestopt`)
};

/**
* | output |
* | --- |
* | "Stopped" |
*
* @param {Video_StoppedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_stopped = /** @type {((inputs?: Video_StoppedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_StoppedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_stopped(inputs)
	if (locale === "ja") return ja_video_stopped(inputs)
	if (locale === "zh") return zh_video_stopped(inputs)
	if (locale === "es") return es_video_stopped(inputs)
	if (locale === "pt") return pt_video_stopped(inputs)
	if (locale === "id") return id_video_stopped(inputs)
	if (locale === "fr") return fr_video_stopped(inputs)
	if (locale === "tl") return tl_video_stopped(inputs)
	if (locale === "vi") return vi_video_stopped(inputs)
	if (locale === "ko") return ko_video_stopped(inputs)
	if (locale === "de") return de_video_stopped(inputs)
	if (locale === "ru") return ru_video_stopped(inputs)
	if (locale === "tr") return tr_video_stopped(inputs)
	if (locale === "it") return it_video_stopped(inputs)
	if (locale === "pl") return pl_video_stopped(inputs)
	if (locale === "uk") return uk_video_stopped(inputs)
	if (locale === "hi") return hi_video_stopped(inputs)
	if (locale === "ar") return ar_video_stopped(inputs)
	if (locale === "ms") return ms_video_stopped(inputs)
	if (locale === "bn") return bn_video_stopped(inputs)
	if (locale === "zh-TW") return zh_tw2_video_stopped(inputs)
	if (locale === "zh-HK") return zh_hk2_video_stopped(inputs)
	if (locale === "ur") return ur_video_stopped(inputs)
	if (locale === "fa") return fa_video_stopped(inputs)
	if (locale === "sw") return sw_video_stopped(inputs)
	if (locale === "nl") return nl_video_stopped(inputs)
	return en_video_stopped(inputs)
});